import createRoute  from '@widesk-ui/tools/createRoute';
import AccountModel from '@models/account/AccountModel';

export default createRoute.table('/accounts', 'account', 'AccountTable', AccountModel.localize('plural'));